import { Link } from "react-router-dom";
import { MessageCircle, Search } from "lucide-react";
import { waLink, WA_MESSAGES } from "@/lib/site";

// Final conversion block reused on most pages.
export const CTASection = ({
  title = "Pronto para planejar sua próxima viagem?",
  text = "Pesquise agora ou fale com a Miríade para receber ajuda na escolha da melhor opção.",
  waMessage = WA_MESSAGES.default,
}) => (
  <section data-testid="cta-section" className="px-4 py-16 sm:px-6 lg:px-8">
    <div className="relative mx-auto max-w-6xl overflow-hidden rounded-3xl bg-brand px-6 py-14 text-center shadow-hover sm:px-12 sm:py-16">
      <div className="absolute inset-0 bg-gradient-to-br from-brand via-brand to-brand-hover" />
      <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-white/10 blur-2xl" />
      <div className="absolute -bottom-12 -left-12 h-56 w-56 rounded-full bg-brand-lilac/20 blur-3xl" />
      <div className="relative">
        <h2 className="mx-auto max-w-2xl font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl">{title}</h2>
        <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-white/80">{text}</p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/buscar-viagens"
            data-testid="cta-search-btn"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-brand transition-all hover:scale-[1.02] sm:w-auto"
          >
            <Search size={18} /> Buscar viagem
          </Link>
          <a
            href={waLink(waMessage)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-whatsapp-btn"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#25D366] px-7 py-3.5 text-sm font-semibold text-white transition-all hover:scale-[1.02] hover:bg-[#1ebe5d] sm:w-auto"
          >
            <MessageCircle size={18} /> Chamar no WhatsApp
          </a>
        </div>
      </div>
    </div>
  </section>
);
